/**
 * InstrumentsToggle Component
 * Toggle button for showing virtual instruments panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Piano } from 'lucide-react';

export const InstrumentsToggle = ({
  showInstruments,
  setShowInstruments,
  isMidiRecording = false,
}) => {
  return (
    <Button
      variant={showInstruments ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowInstruments(!showInstruments)}
      className={`relative p-2 ${showInstruments ? 'bg-purple-500/20 text-purple-400 border border-purple-500/50' : 'text-zinc-400 hover:text-white'}`}
      data-testid="instruments-toggle"
      title="Virtual Instruments"
    >
      <Piano className="w-5 h-5" />
      {isMidiRecording && (
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse" />
      )}
    </Button>
  );
};

export default InstrumentsToggle;
